(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CBPlayer", [], factory);
	else if(typeof exports === 'object')
		exports["CBPlayer"] = factory();
	else
		root["CBPlayer"] = factory();
})(window, function() {
return 